/**
 * The invitation card's shortcuts, side by side, wrapping onto a second line
 * when the card is too narrow for them.
 *
 * "Dona ahora" is a link out of the widget, in a new tab, and stays Spanish,
 * as the card's own text is. "Cursos" opens the chat at the course categories
 * (`rag:start-courses`). Its label follows the language the panel will open
 * in: the tag's `data-lang`, else the host page's `<html lang>` (the loader
 * cannot read the switch the visitor may have pressed, which lives in the
 * frame's storage).
 */

export type InviteLink = { label: string; href: string } | { label: string; action: 'courses' };

export const DONATE_URL = 'https://donaciones.cruzrojaedomex.org/';

/** Left to right, as the card shows them. */
export function inviteLinks(lang: string): InviteLink[] {
  const english = lang.trim().toLowerCase().startsWith('en');
  return [
    { label: 'Dona ahora', href: DONATE_URL },
    { label: english ? 'Courses' : 'Cursos', action: 'courses' },
  ];
}
